import { Component, OnInit, inject } from '@angular/core';
import {
  AuthSandbox,
  RoutesEnum,
  NavigationService, NotificationService
} from '../../../modules/global';
import {first} from 'rxjs/operators';
import {ActivatedRoute} from '@angular/router';
import {UntypedFormControl, Validators} from '@angular/forms';
import { ExternalPageContainerComponent } from '../../components/externap-page-container/external-page-container.component';
import { TranslateDirective } from '@ngx-translate/core';
import { ToggleComponent } from '../../../modules/shared/components/inputs/toggle/toggle.component';
import { ButtonComponent } from '../../../modules/shared/components/buttons/button/button.component';

@Component({
    selector: 'slm-activation',
    templateUrl: './activation.container.html',
    imports: [ExternalPageContainerComponent, TranslateDirective, ToggleComponent, ButtonComponent]
})
export class ActivationContainer implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(NavigationService);
  private readonly authSandbox = inject(AuthSandbox);
  private readonly notification = inject(NotificationService);

  public readonly acceptControl = new UntypedFormControl('', [Validators.requiredTrue]);

  private token: string = null;
  public loading = false;

  ngOnInit() {
    this.route.paramMap
      .pipe(first())
      .subscribe((params) => {
      this.token = params.get('token');
      if (!this.token) {
        this.router.navigate([RoutesEnum.LOGIN]);
      }
    });
  }

  activateUser() {
    if (this.loading) {
      return;
    }
    if (this.acceptControl.invalid) {
      this.acceptControl.markAllAsTouched();
      return;
    }
    this.loading = true;
    this.authSandbox.activate(this.token)
      .subscribe({
        next: () => {
          this.notification.notify('AUTHENTICATION.ACTIVATION_COMPLETED');
          this.router.navigate([RoutesEnum.LOGIN]);
        },
        error: () => this.loading = false
      });
  }
}
